// Scroll-controlled canvas animation using GSAP and ScrollTrigger
// Assumes 90 images named frame_001.jpg to frame_090.jpg in /assets/rotation/

const canvas = document.getElementById('scrollCanvas');
const context = canvas.getContext('2d');

const frameCount = 90;
const currentFrame = index => `rotation/frame_${String(index).padStart(3, '0')}.jpg`;

const images = [];
const imageSeq = {
  frame: 0
};

// Preload images
for (let i = 1; i <= frameCount; i++) {
  const img = new Image();
  img.src = currentFrame(i);
  images.push(img);
}

// Draw image to canvas
function render() {
  if (images[imageSeq.frame] && images[imageSeq.frame].complete) {
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(images[imageSeq.frame], 0, 0, canvas.width, canvas.height);
  }
}

// Setup scroll-triggered animation
gsap.to(imageSeq, {
  frame: frameCount - 1,
  snap: "frame",
  ease: "none",
  scrollTrigger: {
    trigger: "#scrollCanvas",
    start: "top 80%",
    end: "bottom top",
    scrub: 0.5
  },
  onUpdate: render
});

images[0].onload = render;
